import React, { PureComponent } from "react";
import './BckImg.scss';

export default class Image extends PureComponent {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.state = {
      ready: false
    };
  }

  componentDidMount() {
    this._mounted = true;

    const img = new window.Image();
    if (typeof this.props.src === 'undefined') {
      return
    }

    img.onload = () => {
      this._mounted && this.setState({ ready: true })
    };
    img.src = this.props.src;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { src, thumb, className, backgroundStyle } = this.props;
    const noBackgroundImage = ({ backgroundImage, ...rest }) => rest;
    const { ready } = this.state;
    const image = ready ? src : thumb;
    const blur = ready ? 0 : 15;
    const style = {
      zIndex: '-1',
      filter: `blur(${blur}px)`,
      backgroundImage: `url(${image})`,
      position: 'absolute',
      minWidth: '100%',
      minHeight: '100%',
      left: '0',
      top: '0',
      transition: 'filter 0.3s ease-in-out',
      transform: `scale(1.1)`,
      ...backgroundStyle
    };

    const styleName = className || null;

    return (
      <div  style={{ position: 'relative' }} className={styleName}>
        {this.props.children}
        <div
          style={ src ? style : noBackgroundImage(style)} />
      </div>
    )
  }
}


// backgroundAttachment: 'fixed',
//   backgroundPosition: 'center',
//   backgroundRepeat: 'no-repeat',
//   backgroundSize: 'cover',



// WEBPACK FOOTER //
// ./src/components/Common/BckImg/BckImg.jsx